// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const RepeatableIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.11 123.69999999999999">
          <path fill="inherit" d="M100.11 71.812l-4.48-2.1-10.513 4.924-25.473 11.95-47.872-22.46L.11 58.54.107 71.08l59.42 27.88 37.67-17.663 2.91-1.365.002-8.12"/>
          <path fill="inherit" d="M100.103 50.53l-4.276-2.003-10.492 4.917-12.2 5.72L62.63 64.09l-2.778 1.298L34.47 53.483l-10.41-4.88-12.08-5.663-10.406-4.888-1.465.688L.107 49.8l11.765 5.513 10.415 4.89L59.74 77.767l14.97-7.012 10.495-4.933 12.2-5.716 2.704-1.266"/>
          <path fill="inherit" d="M100.11 37.75l-2.503 1.174-12.195 5.713-10.495 4.93-12.193 5.717-2.79 1.298-25.374-11.91-12.077-5.653-10.418-4.895L0 28.46v-1l.11-9.812L37.736 0l62.367 29.24"/>
        </svg>
      )
    }
  </Icon>
);

export default RepeatableIcon;
